import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { processEnv } from 'components/configuration/environmentVariables'
import PremiumInfoIconTooltip from 'pages/ProjectsPage/WorkspacePage/components/PremiumInfoIconTooltip'
import React from 'react'
import { DialogContext } from '../DialogContext'

interface SlideContentTabsProps {
    type?: ListingLevel
}

const useStyles = makeStyles((theme) => ({
    tabContainer: {
        margin: theme.spacing(6, 1.5),
    },
    tabButton: {
        color: '#304959',
        textTransform: 'uppercase',
        backgroundColor: 'transparent',
        margin: theme.spacing(0, 1.5),
        '&:hover': {
            backgroundColor: 'transparent',
        },
        fontSize: pxToRem(13),
        fontWeight: 400,
    },
    tabButtonActive: {
        color: theme.palette.common.white,
        margin: theme.spacing(0, 1.5),
        boxShadow:
            '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
        padding: theme.spacing(1, 2),
        textTransform: 'uppercase',
        backgroundColor: '#304959',
        '&:hover': {
            backgroundColor: '#304959',
        },
        fontSize: pxToRem(13),
        fontWeight: 400,
    },
    infoIconContainer: {
        margin: theme.spacing(1, 4, 0, 'auto'),
    },
}))

export const SlideContentTabs: React.FC<SlideContentTabsProps> = ({
    type = ListingLevel.Manufacturer,
}) => {
    const { activeTab, handleTabChange } = React.useContext(DialogContext)

    const [isTooltipOpen, setTooltipOpen] = React.useState(false)

    const classes = useStyles()

    const handleClickPremiumIcon = React.useCallback(() => {
        setTooltipOpen(true)
    }, [])

    const handleClickOutsidePremiumIcon = React.useCallback(() => {
        setTooltipOpen(false)
    }, [])

    return (
        <GridContainer className={classes.tabContainer}>
            <GridItem>
                {type !== ListingLevel.Manufacturer &&
                    type !== ListingLevel.PremiumProprietary && (
                        <Button
                            data-testid="propertiesButton"
                            onClick={() => handleTabChange?.('properties')}
                            className={
                                activeTab === 'properties'
                                    ? classes.tabButtonActive
                                    : classes.tabButton
                            }
                        >
                            Properties
                        </Button>
                    )}
                <Button
                    data-testid="resourcesButton"
                    onClick={() => handleTabChange?.('resources')}
                    className={
                        activeTab === 'resources'
                            ? classes.tabButtonActive
                            : classes.tabButton
                    }
                >
                    Resources
                </Button>
            </GridItem>
            {processEnv.REACT_APP_EnableBadgelessCards !== '1' && (
                <GridItem className={classes.infoIconContainer}>
                    <PremiumInfoIconTooltip
                        open={isTooltipOpen}
                        mode="productSelection"
                        size="small"
                        onClick={handleClickPremiumIcon}
                        onClickOutside={handleClickOutsidePremiumIcon}
                    />
                </GridItem>
            )}
        </GridContainer>
    )
}
